import {
  SHOW_OVERLAY,
  HIDE_OVERLAY,
  SHOW_LOADER,
  HIDE_LOADER,
  ENQUEUE_SNACKBAR,
  CLOSE_SNACKBAR,
  REMOVE_SNACKBAR,
  SET_MODULE_NAME,
  MOBILE_DRAWER,
  SIDEBAR_COLLAPSED
} from '../constants/action.constant'
import React from 'react'
import Button from '@mui/material/Button'

export const showOverlay = () => ({ type: SHOW_OVERLAY })

export const hideOverlay = () => ({ type: HIDE_OVERLAY })

export const showLoadingIndicator = () => ({ type: SHOW_LOADER })

export const hideLoadingIndicator = () => ({ type: HIDE_LOADER })

export const setModuleName = (name) => ({ type: SET_MODULE_NAME, name })

export const showMobileDrawer = (showMobileDrawer) => ({ type: MOBILE_DRAWER, showMobileDrawer })

export const setSidebarCollapsed = (isCollapsed) => ({ type: SIDEBAR_COLLAPSED, isCollapsed })

export const enqueueSnackbar = (notification) => {
  const key = notification.options && notification.options.key

  return {
    type: ENQUEUE_SNACKBAR,
    notification: {
      ...notification,
      key: key || new Date().getTime() + Math.random()
    }
  }
}

export const closeSnackbar = key => ({
  type: CLOSE_SNACKBAR,
  dismissAll: !key, // dismiss all if no key has been defined
  key
})

export const removeSnackbar = key => ({
  type: REMOVE_SNACKBAR,
  key
})

export const successSnackBar = (msg) => {
  return (dispatch) => {
    dispatch(enqueueSnackbar({
      message: msg,
      options: {
        key: new Date().getTime() + Math.random(),
        variant: 'success',
        autoHideDuration: 8000
      }
    }))
  }
}

export const errorSnackBar = (msg) => {
  return (dispatch) => {
    dispatch(enqueueSnackbar({
      message: msg,
      options: {
        key: new Date().getTime() + Math.random(),
        variant: 'error',
        autoHideDuration: 5000
      }
    }))
  }
}

export const warningSnackBar = (msg) => {
  return (dispatch) => {
    dispatch(enqueueSnackbar({
      message: msg,
      options: {
        key: new Date().getTime() + Math.random(),
        variant: 'warning',
        autoHideDuration: 8000
      }
    }))
  }
}

export const infoSnackBar = (msg) => {
  return (dispatch) => {
    dispatch(enqueueSnackbar({
      message: msg,
      options: {
        key: new Date().getTime() + Math.random(),
        variant: 'info',
        autoHideDuration: 8000
      }
    }))
  }
}

export const defaultSnackbar = (msg) => {
  return (dispatch) => {
    dispatch(enqueueSnackbar({
      message: msg,
      options: {
        key: new Date().getTime() + Math.random(),
        autoHideDuration: 8000
      }
    }))
  }
}

export const persistantSnackbar = (msg, type) => {
  const myKey = new Date().getTime() + Math.random()
  return (dispatch) => {
    dispatch(enqueueSnackbar({
      message: msg || '',
      options: {
        key: myKey,
        // persist: true,
        variant: type,
        autoHideDuration: 8000,
        // action: key => (
        //   <Button onClick={() => dispatch(closeSnackbar(myKey))}><Clear style={{ color: 'white' }} /></Button>
        // )
      }

    }))
  }
}

export const simulateOnSnacker = (msg) => {
  const myKey = new Date().getTime() + Math.random()
  return (dispatch) => {
    dispatch(enqueueSnackbar({
      message: msg,
      options: {
        key: myKey,
        persist: true,
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        }
      }

    }))
  }
}

export const customContent = (msg) => {
  const myKey = new Date().getTime() + Math.random()
  return (dispatch) => {
    dispatch(enqueueSnackbar({
      message: msg,
      options: {
        key: myKey,
        persist: true,
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        content: () => (<h1>Hello</h1>)
      }

    }))
  }
}

export const priorities = [
  {
    value: 1,
    key: 'Urgent'
  },
  {
    value: 2,
    key: 'High'
  },
  {
    value: 3,
    key: 'Standard'
  },
  {
    value: 4,
    key: 'Low'
  }
]

let reloadNotificationState = {
  hasFeatureFlagChanges: false,
  hasSubscriptionChanges: false
};

/**
 * Dispatches a top-center reload notification asking the user to refresh the page.
 * Merges subscription and feature flag update states to display a dynamic combined message without duplicate banners.
 *
 * @param {'feature_flags'|'subscription'} [changeType='feature_flags'] - The type of settings change performed.
 * @returns {Function} Redux thunk function.
 */
export const showReloadNotification = (changeType = 'feature_flags') => {
  if (changeType === 'subscription') {
    reloadNotificationState.hasSubscriptionChanges = true;
  } else if (changeType === 'feature_flags') {
    reloadNotificationState.hasFeatureFlagChanges = true;
  }

  let message = 'Settings updated. Please reload the page to apply changes.';
  if (reloadNotificationState.hasFeatureFlagChanges && reloadNotificationState.hasSubscriptionChanges) {
    message = 'Account subscription & feature flags updated. Please reload the page to apply changes.';
  } else if (reloadNotificationState.hasSubscriptionChanges) {
    message = 'Account subscription updated. Please reload the page to apply changes.';
  } else if (reloadNotificationState.hasFeatureFlagChanges) {
    message = 'Feature flags updated. Please reload the page to apply changes.';
  }

  return (dispatch, getState) => {
    const existingNotifications = getState()?.common?.notifications || [];
    const activeReloadNotif = existingNotifications.find(n => n.options?.isReloadNotification && !n.dismissed);

    if (activeReloadNotif && activeReloadNotif.message === message) {
      return;
    }

    if (activeReloadNotif) {
      dispatch(closeSnackbar(activeReloadNotif.key));
    }

    const newKey = `reload_notification_${Date.now()}`;

    dispatch(enqueueSnackbar({
      message,
      options: {
        key: newKey,
        isReloadNotification: true,
        variant: 'info',
        persist: true,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        action: () => (
          <Button
            size="small"
            className="text-white text-decoration-underline fw-bold"
            onClick={() => {
              reloadNotificationState = { hasFeatureFlagChanges: false, hasSubscriptionChanges: false };
              window.location.reload();
            }}
          >
            Reload Page
          </Button>
        )
      }
    }));
  };
};